import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { HttpClient, HttpRequest, HttpParams, HttpHeaders } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { map, finalize } from 'rxjs/operators';
import { LangService } from '../lang/lang.service';
import { ConfigService } from '../config/config.service';
import { environment } from '../../../environments/environment';
import { AuthService as SocialAuthService, FacebookLoginProvider, GoogleLoginProvider } from 'angularx-social-login';
// https://theinfogrid.com/tech/developers/angular/facebook-login-angular-rest-api/
import { AnalyticsService } from '../analytics/analytics.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private LoggedStatus = new BehaviorSubject<any>(this.isLoggedIn());
  loggedStatusObs = this.LoggedStatus.asObservable();

  loggedUser = false;

  constructor(private http: HttpClient, private socialAuthService: SocialAuthService,
    @Inject(PLATFORM_ID) private platform: Object,
    private lang: LangService,
    private config: ConfigService,
    private analytics: AnalyticsService) { }

  login(post): Observable<any> {
    const getLoginUrl: any = environment.apiUrl.baseUrl + environment.apiUrl.services.login;
    return this.http
      .post(getLoginUrl, { 'email': post['email'], 'password': post['password'], 'language_code': this.lang.getCurrentLang() })
      .pipe(map(
        resp => {
          if (resp) {
            localStorage.setItem('token', resp['token']);
            localStorage.setItem('user', JSON.stringify(resp['user']));
            localStorage.setItem('x7uER!n', btoa(post['email']));
            localStorage.setItem('x71uER!n', btoa(post['password']));
            this.changeLoginStatus();
          }
          return resp;
        },
        err => {
          return err;
        }
      ));
  }

  registration(post): Observable<any> {
    const getRegistrationUrl: any = environment.apiUrl.baseUrl + environment.apiUrl.services.registration;
    return this.http
      .post(getRegistrationUrl,
        {
          'name': post['name'], 'email': post['email'], 'password': post['password'],
          't_and_c_consent_level': post['termsConsent'] ? this.config.configurations.t_and_c_consent_level : 0,
          'marketing_consent_level': post['marketingConsent'] ? this.config.configurations.marketing_consent_level : 0,
          'language_code': this.lang.getCurrentLang()
        })
      .pipe(map(
        resp => {
          if (resp) {
            localStorage.setItem('token', resp['token']);
            localStorage.setItem('user', JSON.stringify(resp['user']));
            localStorage.setItem('x7uER!n', btoa(post['email']));
            localStorage.setItem('x71uER!n', btoa(post['password']));
            this.changeLoginStatus();
          }
          return resp;
        },
        err => {
          this.changeLoginStatus();
          return err;
        }
      ));
  }

  getUser(token): Observable<any> {
    const getUserURL: any = environment.apiUrl.baseUrl + environment.apiUrl.services.registration;
    const options = token ? { headers: new HttpHeaders({ 'Authorization': 'Bearer ' + token }) } : {};
    return this.http
      .get(getUserURL, options)
      .pipe(map(
        resp => {
          if (resp) {
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(resp['user']));
            this.changeLoginStatus();
          }
          return resp;
        },
        err => {
          localStorage.removeItem('user');
          localStorage.removeItem('token');
          this.changeLoginStatus();
          return err;
        }
      ));
  }

  passwordRecovery(post): Observable<any> {
    const getpasswordRecoveryUrl: any = environment.apiUrl.baseUrl + environment.apiUrl.services.passwordRecovery;
    return this.http
      .post(getpasswordRecoveryUrl,
        {
          'email': post['email'],
          'language_code': this.lang.getCurrentLang()
        })
      .pipe(map(
        resp => {
          if (resp) {
          }
          this.changeLoginStatus();
          return resp;
        },
        err => {
          return err;
        }
      ));
  }

  passwordReset(post): Observable<any> {
    const getpasswordResetUrl: any = environment.apiUrl.baseUrl + environment.apiUrl.services.passwordReset;
    return this.http
      .post(getpasswordResetUrl,
        {
          'email': post['email'],
          'password': post['password'],
          'token': post['token'],
          'language_code': this.lang.getCurrentLang()
        })
      .pipe(map(
        resp => {
          if (resp) {
            console.log(resp);
            this.changeLoginStatus();
          }
          return resp;
        },
        err => {
          return err;
        }
      ));
  }

  logout() {
    if (!this.isLoggedIn()) {
      return;
    }
    const token: any = this.getUserToken();
    const getLogoutUrl: any = environment.apiUrl.baseUrl + environment.apiUrl.services.logout;
    const opts = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + token
      })
    };
    return this.http
      .post(getLogoutUrl, {}, opts)
      .pipe(map(
        resp => {
          if (resp) { }
          localStorage.removeItem('user');
          localStorage.removeItem('token');
          localStorage.removeItem('x7uER!n');
          localStorage.removeItem('x71uER!n');
          this.changeLoginStatus();
          return resp;
        },
        err => {
          localStorage.removeItem('user');
          localStorage.removeItem('token');
          localStorage.removeItem('x7uER!n');
          localStorage.removeItem('x71uER!n');
          this.changeLoginStatus();
          return err;
        }
      ))
      .pipe(
        finalize(() => {
          localStorage.removeItem('user');
          localStorage.removeItem('token');
          this.changeLoginStatus();
        }));
  }

  changeUserAvtar(avatarImg) {
    const token: any = this.getUserToken();
    const avatarUrl: any = environment.apiUrl.baseUrl + environment.apiUrl.services.avatar;
    const options = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + token
      }),
    };
    return this.http
      .post(avatarUrl, avatarImg, options)
      .pipe(map(
        (resp: any) => {
          const userObj = JSON.parse(localStorage.getItem('user'));
          if (userObj) {
            userObj.avatar = resp.user.avatar;
            localStorage.setItem('user', JSON.stringify(userObj));
            this.changeLoginStatus();
          }
          return resp;
        },
        err => {
          return err;
        }
      ));
  }

  changeUserPepoleNumber(pepoleNumber) {
    const token: any = this.getUserToken();
    const userUrl: any = environment.apiUrl.baseUrl + environment.apiUrl.services.registration;
    const options = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
    };
    const userObject = localStorage.getItem('user');
    const user = JSON.parse(userObject);
    user.profile.number_of_people = pepoleNumber;
    localStorage.setItem('user', JSON.stringify(user));
    return this.http
      .put(userUrl, `user[profile][number_of_people]=${pepoleNumber}`, options)
      .pipe(map(
        (resp: any) => {
          localStorage.setItem('user', JSON.stringify(resp['user']));
          return resp;
        },
        err => {
          return err;
        }
      ));
  }

  isLoggedIn() {
    if (isPlatformBrowser(this.platform)) {
      if (localStorage.getItem('user')) {
        this.loggedUser = true;
        return true;
      }
    }
    this.loggedUser = false;
    return false;
  }

  getUserFirstName() {
    if (this.isLoggedIn()) {
      const userObj = JSON.parse(localStorage.getItem('user'));
      return userObj.profile.first_name != null ? userObj.profile.first_name : 'user';
    }
  }

  getUserAvatar() {
    if (this.isLoggedIn()) {
      const userObj = JSON.parse(localStorage.getItem('user'));
      return userObj.avatar != null ? userObj.avatar : {};
    }
  }

  getCurrentUserObject() {
    if (this.isLoggedIn()) {
      const userObj = JSON.parse(localStorage.getItem('user'));
      return userObj;
    }
    return undefined;
  }

  getUserSearchCount() {
    if (this.isLoggedIn()) {
      const userObj = JSON.parse(localStorage.getItem('user'));
      return userObj.profile.search_count != null ? userObj.profile.search_count : 0;
    }
  }

  updateUserSearchCount() {
    if (this.isLoggedIn()) {
      const userObj = JSON.parse(localStorage.getItem('user'));
      userObj.profile.search_count = userObj.profile.search_count != null ? userObj.profile.search_count + 1 : 1;
      localStorage.setItem('user', JSON.stringify(userObj));
      return userObj.profile.search_count != null ? userObj.profile.search_count : 0;
    }
  }

  getUserToken() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let token = urlParams.get('token');
    if(token){
      return token;
    }else if (this.isLoggedIn()) {
      token = localStorage.getItem('token');
      if(!token){
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        token = urlParams.get('token');
      }
      return token;
    }
  }

  fbLogin(form: any, redirectUrl?, successCallback?, failCallback?) {
    const socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
    this.socialAuthService.signIn(socialPlatformProvider).then(
      (userData) => {
        this.fbServerLogin(userData.authToken, form.termsConsent, form.marketingConsent)
          .subscribe(
            res => {
              if (res) {
                localStorage.setItem('token', res['token']);
                localStorage.setItem('user', JSON.stringify(res['user']));
                res.service = 'facebook';
                if (successCallback) {
                  successCallback(res);
                }
              }
            }, err => {
              if (failCallback) {
                failCallback(err);
              }
              return err;
            });
      }
    );
  }

  fbServerLogin(token: string, termsConsent, marketingConsent): Observable<any> {
    const fbLoginUrl: any = environment.apiUrl.baseUrl + environment.apiUrl.services.fbLogin;
    return this.http
      .post(fbLoginUrl,
        {
          'access_token': token,
          't_and_c_consent_level': termsConsent ? this.config.configurations.t_and_c_consent_level : 0,
          'marketing_consent_level': marketingConsent ? this.config.configurations.marketing_consent_level : 0,
          'language_code': this.lang.getCurrentLang()
        })
      .pipe(map(
        resp => {
          if (resp) {
            localStorage.setItem('token', resp['token']);
            localStorage.setItem('user', JSON.stringify(resp['user']));
            this.changeLoginStatus();
          }
          return resp;
        },
        err => {
          return err;
        }
      ));
  }

  gLogin(form: any, redirectUrl?, successCallback?, failCallback?) {
    const socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
    this.socialAuthService.signIn(socialPlatformProvider).then(
      (userData: any) => {
        this.gServerLogin(userData.idToken, form.termsConsent, form.marketingConsent)
          .subscribe(
            res => {
              if (res) {
                localStorage.setItem('token', res['token']);
                localStorage.setItem('user', JSON.stringify(res['user']));
                res.service = 'google';
                if (successCallback) {
                  successCallback(res);
                }
              }
            },
            err => {
              if (failCallback) {
                failCallback(err);
              }
              return err;
            }
          );
      }
    );
  }

  gServerLogin(token: string, termsConsent, marketingConsent): Observable<any> {
    const gLoginUrl: any = environment.apiUrl.baseUrl + environment.apiUrl.services.gLogin;
    return this.http
      .post(gLoginUrl,
        {
          'access_token': token,
          't_and_c_consent_level': termsConsent ? this.config.configurations.t_and_c_consent_level : 0,
          'marketing_consent_level': marketingConsent ? this.config.configurations.marketing_consent_level : 0,
          'language_code': this.lang.getCurrentLang()
        })
      .pipe(map(
        resp => {
          if (resp) {
            localStorage.setItem('token', resp['token']);
            localStorage.setItem('user', JSON.stringify(resp['user']));
            this.changeLoginStatus();
          }
          return resp;
        },
        err => {
          return err;
        }
      ));
  }

  changeLoginStatus() {
    const _val = this.isLoggedIn();
    this.LoggedStatus.next(_val);
    this.analytics.setUserProperties();
  }

  getUserCurrencyCode() {
    const _countryObj = this.config.getUserDefaultCountry();
    return _countryObj.currency_code;
  }

  getPublicVouchers(): Observable<any> {
    const publicVouchersURL = environment.apiUrl.baseUrl + environment.apiUrl.services.publicVouchers;
    const options: any = {};
    options.headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.getUserToken(),
    });
    options.params = new HttpParams({});
    options.params = options.params.append('currency_code', this.getUserCurrencyCode());
    return this.http
      .get(publicVouchersURL, options)
      .pipe(map(
        (response: any) => {
          return response;
        }, (error: any) => {
          return error;
        }
      ));
  }

  getUserWallet(): Observable<any> {
    const walletURL = environment.apiUrl.baseUrl + environment.apiUrl.services.wallet;
    const options: any = {};
    options.headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.getUserToken(),
    });
    options.params = new HttpParams({});
    options.params = options.params.append('currency_code', this.getUserCurrencyCode());
    return this.http
      .get(walletURL, options)
      .pipe(map(
        (response: any) => {
          return response;
        }, (error: any) => {
          return error;
        }
      ));
  }

  refreshToken(): Observable<any> {
    const refreshTokenUrl = environment.apiUrl.baseUrl + environment.apiUrl.services.refreshToken;
    const options: any = {};
    options.headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.getUserToken(),
    });
    return this.http
      .get(refreshTokenUrl, options)
      .pipe(map(
        (resp: any) => {
          if (resp) {
            localStorage.setItem('token', resp['token']);
          }
          return resp;
        }, (error: any) => {
          return error;
        }
      ));
  }

  cachedRequests: Array<HttpRequest<any>> = [];

  public collectFailedRequest ( request ): void {
    this.cachedRequests.push( request );
  }

  public retryFailedRequests(): void {
    this.cachedRequests.forEach( request => {
        request = request.clone( {
            setHeaders: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${ this.getUserToken() }`
            }
        });
    });
  }
}
